<template>
    <div v-if="document_folders && !loading">
        <b-row>
            <b-col cols="6" md="2" class="mb-4">
                <b-button block squared variant="sf" v-b-modal.add-document-folder class="folder-tile primary"><font-awesome-icon :icon="['fal', 'folder-plus']"></font-awesome-icon></b-button>
                <b-modal id="add-document-folder" title="Add a new folder" size="lg">
                    <c-input label="Name" v-model="new_folder_name" :horizontal="true"></c-input>
                    <font-awesome-picker v-model="new_folder_icon"></font-awesome-picker>
                    <template v-slot:modal-footer>
                        <b-button-group>
                            <b-button variant="outline-success" squared @click="createDocumentFolder(new_folder_name, new_folder_icon)"><font-awesome-icon :icon="['fal', 'save']"></font-awesome-icon></b-button>
                        </b-button-group>
                    </template>
                </b-modal>
            </b-col>
            <b-col class="mb-4" cols="6" md="2" v-for="(document_folder) in document_folders">
                <b-button block squared variant="outline-dark" class="folder-tile d-flex"
                        :to="'/documents/manage/'+document_folder.id/*.name.toString().toLowerCase().split(' ').join('-')*/"
                ><span class="m-auto text-center"><font-awesome-icon v-if="document_folder.icon" :icon="['fal', document_folder.icon]" class="mr-2"></font-awesome-icon>{{ document_folder.name }}</span></b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import ToastNotifications from "../shared/mixins/ToastNotifications";
  import DocumentFolder from "../../models/DocumentFolder";
  import FontAwesomePicker from "./FontAwesomePicker";

  export default {
    name: 'ManageRootDocumentFolders',
    components: {FontAwesomePicker},
    mixins: [ToastNotifications],
    data() {
      return {
        loading: true,
        document_folders: null,
        new_folder_name: null,
        new_folder_icon: null,
      };
    },
    methods: {
      createDocumentFolder(name, icon) {
        console.log(name, icon);
        return DocumentFolder.api().create({name, icon}).then((response) => {
          let document_folder = response.entities.document_folders[0];
          this.document_folders.push(document_folder);
          this.new_folder_name = null;
          this.new_folder_icon = null;
          this.$bvModal.hide('add-document-folder');
          return document_folder;
        });
      },
      fetchDocumentFolders(nextPageUrl = null) {
        let params = { parent_folder_id: null, private: 0, url: nextPageUrl };
        return DocumentFolder.api().fetch(params).then((documentFoldersResponse) => {
          let folders = DocumentFolder.query().where('parent_folder_id', null).where('private', 0).get();

          if(!folders) {
            folders = [];
          }

          this.document_folders = folders;
          this.loading = false;

          const documentFoldersResponsePagination = documentFoldersResponse.response.data.data.pagination;

          // if there's a next page then fetch documents on the next page too
          if (documentFoldersResponsePagination.next_page_url) {
            this.fetchDocumentFolders(documentFoldersResponsePagination.next_page_url);
          }

          return this.loading;
        });
      }
    },
    created() {
      this.fetchDocumentFolders();
    }
  }
</script>
<style lang="scss">
    .folder-tile {
        &.primary svg {
            font-size: 2em;
        }
        font-size: 1.6em;
        height: 140px;
    }
</style>